import { GetE2EEncryptionStatus } from './e2ee';
import {
  setE2EEncryptionEnabledFlag,
  getE2EEncryptionEnabledFlag,
} from '../storage';

export const setE2EEncryptionEnabled = async (identificationId) => {
  try {
    const response = await GetE2EEncryptionStatus(identificationId);
    if (response.GetE2EEncryptionStatusResult) {
      setE2EEncryptionEnabledFlag(response.status);
    } else {
      setE2EEncryptionEnabledFlag('false');
    }
  } catch (error) {
    console.error('Error getting E2E setting:', error);
    setE2EEncryptionEnabledFlag('false');
  }
};
